import ModalEducatorDashboard from './ModalEducatorDashboard';
export const MODAL_EDUCATOR_DASHBOARD = 'MODAL_EDUCATOR_DASHBOARD';

export default ModalEducatorDashboard;